import {
    faBox,
    faCircleMinus,
    faHeadset,
    faMessageBot,
    faThumbsDown,
    faThumbsUp,
} from "@fortawesome/pro-solid-svg-icons";
import { ExperienceDriverRating, RationaleType } from "@edgetier/watchtower-types";
import {
    ExperienceDriver,
    IExperienceDriverDescriptor,
    IExperienceDriverRatingDescriptor,
} from "types-for/experience-drivers/experience-drivers.types";

/**
 * The single source of truth for the three experience-driver dimensions. The interaction panel and, with GAP-1995, the
 * Experience Score popover read their labels, icons and ordering from here so the surfaces cannot drift apart.
 */
export const EXPERIENCE_DRIVERS: Record<ExperienceDriver, IExperienceDriverDescriptor> = {
    [ExperienceDriver.ProductProcess]: {
        label: "Product/Process",
        icon: faBox,
        ratingField: "productExperienceRating",
        rationaleType: RationaleType.ProductExperienceDrivers,
        queryParameter: "productExperienceRating",
    },
    [ExperienceDriver.BotHandling]: {
        label: "Bot Handling",
        icon: faMessageBot,
        ratingField: "botExperienceRating",
        rationaleType: RationaleType.BotExperienceDrivers,
        queryParameter: "botExperienceRating",
    },
    [ExperienceDriver.AgentHandling]: {
        label: "Agent Handling",
        icon: faHeadset,
        ratingField: "agentExperienceRating",
        rationaleType: RationaleType.AgentExperienceDrivers,
        queryParameter: "agentExperienceRating",
    },
};

/** Fixed render order for every surface. Product first, then the customer's path through bot and agent. */
export const EXPERIENCE_DRIVER_ORDER = [
    ExperienceDriver.ProductProcess,
    ExperienceDriver.BotHandling,
    ExperienceDriver.AgentHandling,
] as const;

/** Every rating uses the "light" variant, so the three chips read as one set. */
export const EXPERIENCE_DRIVER_RATINGS: Record<ExperienceDriverRating, IExperienceDriverRatingDescriptor> = {
    [ExperienceDriverRating.Negative]: { label: "Negative", color: "error", variant: "light", icon: faThumbsDown },
    [ExperienceDriverRating.Neutral]: { label: "Neutral", color: "gray", variant: "light", icon: faCircleMinus },
    [ExperienceDriverRating.Positive]: { label: "Positive", color: "success", variant: "light", icon: faThumbsUp },
};

/** Shown in place of the driver list when an interaction has no rated dimension. */
export const NO_EXPERIENCE_DRIVERS_TEXT = "No Experience Drivers applied to this interaction";
